import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Hidden,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import _ from 'lodash';

import radioImgXS from 'assets/images/podcast200x200.jpg';
import radioImg from 'assets/images/podcast200x200.jpg';

import { usePrevious } from 'hooks';

import { HeartButton, ShareButton } from 'modules3/components';
import { ImageSkeleton } from 'common/ui/skeleton-ui';
import { ShareButtons } from 'modules/player/components';
import PlayPauseButton from 'modules3/playbar/components/PlayPauseButton';

import container from './PodCastDetailCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
    marginBottom: 10
  },
  container: {
    padding: theme.spacing(2),
    paddingBottom: 0,
    fontFamily: 'Arial',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  cardImage: {
    [theme.breakpoints.up('sm')]: {
      borderBottomLeftRadius: 10,
      borderTopLeftRadius: 10,
      borderLeft: 'solid 1px',
      borderTop: 'solid 1px',
      borderBottom: 'solid 1px',
      borderColor: theme.palette.borderColor
    },
    [theme.breakpoints.down('xs')]: {
      width: 330,
      height: 270,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderLeft: 'solid 1px',
      borderTop: 'solid 1px',
      borderRight: 'solid 1px',
      borderColor: theme.palette.borderColor
    }
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  subtitle: {
    fontSize: 14,
    marginLeft: 15,
    color: theme.palette.textColor2,
    display: 'flex',
    justifyContent: 'left',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center'
    }
  },
  locator: {
    marginTop: 5,
    marginLeft: -15,
    border: '3px solid #ff0066',
    position: 'absolute',
    borderRadius: '100%',
    background: '#ff0066'
  },
  description: {
    fontSize: 14,
    overflow: 'hidden',
    // textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    [theme.breakpoints.down('xs')]: {
      marginTop: 30
    }
  },
  descriptionMore: {
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      marginTop: 30
    }
  },
  genresMore: {
    fontSize: 14,
    overflow: 'hidden',
    // textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    [theme.breakpoints.down('xs')]: {
      marginTop: 30
    }
  },
  more: {
    fontSize: 14,
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1)
    // marginBottom: 10
  },
  listItem: {
    margin: '0px 10px',
    position: 'relative',
    border: '1px solid',
    borderColor: theme.palette.borderColor,
    borderBottomColor: theme.palette.borderColor,
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
    fontFamily: 'Arial',
    width: '100%',
    maxWidth: '100%',
    marginBottom: theme.spacing(1),
    borderRadius: 7,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    boxShadow: '0 4px 15px 0px rgba(248, 71, 62, 0.05)',
    '&:hover': {
      background: theme.palette.hoverColorItem
    },
    '&:hover $titleText': {
      color: theme.palette.pink
    },
    '&:hover $outerCircle': {
      background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 22px, ${theme.palette.hoverColorItem} 23px)`
    },
    '&:hover $trendingBoxOverlay': {
      opacity: 1
    },
    '&:hover $actionOptions': {
      opacity: 1
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      maxHeight: 100,
      justifyContent: 'center',
      textAlign: 'center'
    }
  },
  cardWrapper: {
    minWidth: 200,
    minHeight: 50,
    width: 200,
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative'
  },
  trendingBoxOverlay: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 1,
    width: 233,
    height: 202,
    borderRadius: 10,
    display: 'block',
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.2)',
    transition: 'all 0.6s ease 0s'
  },
  outerCircle: {
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      width: 203,
      height: 40,
      zIndex: 999,
      marginTop: 81,
      marginLeft: 120,
      position: 'absolute',
      transform: 'rotate(270deg)',
      background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 30px, ${theme.palette.outerCircle} 31px)`,
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat'
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 350,
      height: 30,
      marginLeft: 0,
      display: 'flex',
      flex: '1 1 0%',
      zIndex: 999,
      marginTop: -8,
      position: 'absolute',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`,
      [theme.breakpoints.between('396', '410')]: {
        minWidth: 360,
        background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`
      },
      [theme.breakpoints.between('410', '450')]: {
        minWidth: 380,
        background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`
      },
      [theme.breakpoints.between('450', '500')]: {
        minWidth: 420,
        background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`
      },
      [theme.breakpoints.between('500', '660')]: {
        minWidth: 470,
        background: `-webkit-radial-gradient(50% 0, circle, rgba(0,0,0,0) 26px, ${theme.palette.outerCircle} 27px)`
      }
    }
  },
  playerIcon: {
    cursor: 'pointer',
    zIndex: 999,
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      padding: '52px 0px 0px 107px',
      marginTop: 24,
      marginLeft: 68
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      padding: '0px 0px 0px 16px',
      marginTop: -30,
      marginLeft: 137,
      [theme.breakpoints.between('396', '410')]: {
        marginLeft: 142
      },
      [theme.breakpoints.between('410', '450')]: {
        marginLeft: 152
      },
      [theme.breakpoints.between('450', '500')]: {
        marginLeft: 172
      },
      [theme.breakpoints.between('500', '660')]: {
        marginLeft: 197
      }
    }
  },
  playIcon: {
    width: 50,
    height: 50,
    fill: '#fff',
    background: '#ff0066',
    borderRadius: '50%'
  },
  textWrapper: {
    flex: '1 1 0%',
    width: '50%',
    minWidth: 0,
    lineHeight: '25px',
    display: 'flex',
    paddingLeft: 10,
    marginLeft: 40,
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  textWrapper1: {
    lineHeight: '25px'
  },
  detailWrapper: {
    cursor: 'pointer'
  },
  mediaWrapper: {
    width: 655,
    height: 150,
    // padding: theme.spacing(1),
    margin: 'auto',
    borderRadius: 10,
    [theme.breakpoints.down('xs')]: {
      width: 330,
      height: 250
    }
  },
  icon: {
    width: 44,
    height: 44,
    fill: '#fff',
    // marginTop: 35,
    background: '#ff0066',
    borderRadius: '50%'
  },
  informationContainer: {
    padding: '8px 16px',
    fontFamily: 'Arial',
    display: 'flex'
  },
  informationTitle: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  detailTitle: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  details: {
    fontSize: 14
  },
  expand: {
    padding: 0,
    // marginLeft: 'auto',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    padding: 0,
    transform: 'rotate(180deg)'
  },
  iconMore: {
    display: 'inline-block',
    color: 'rgb(37, 37, 37)',
    fill: theme.palette.iconColor,
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    '&:hover': {
      color: theme.palette.iconHover,
      fill: theme.palette.iconHover
    }
  },
  socialWrapper: {
    padding: 5
  }
}));

const PodCastDetailCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const style = {
    fill: theme.palette.pink
  };

  const {
    audioPlayer,
    podcastState: {
      genres,
      podcasts,
      genresPodcasts,
      currentPodcast,
      podcastEpisodes
    },
    playerPodCastState: { episodeid, player },
    userHistoryPodcastState: { heartedPodcastIds, history },
    podcastPlaylistState: { playlists, currentlyViewedPlaylist },
    onEpisodePlayerStart,
    onFavouritePodcast,
    onRemoveFavoritePodcastStart,
    onShowSnackbarNotification,
    onSetCurrentPodcastid,
    onSetPodcastQueue
  } = props;
  const playerRef = audioPlayer.current;
  const [socialShareMenuOpen, setSocialShareMenuOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [showMore, setShowMore] = useState(true);
  const [expanded, setExpanded] = React.useState(false);
  const [latestEpisodeId, setLatestEpisodeId] = useState([]);
  const [podcastDetailState, setPodcastDetailState] = useState({
    podcast_id: '',
    title: '',
    country: '',
    author: '',
    genre: [],
    language: '',
    release_date: '',
    image: '',
    description: ''
  });

  const podcastDetail1 = genresPodcasts[currentPodcast];
  const prevPodcastDetail1 = usePrevious(genresPodcasts[currentPodcast]);
  const podcastDetail2 = history[currentPodcast];
  const prevPodcastDetail2 = usePrevious(history[currentPodcast]);

  useEffect(() => {
    if (
      !_.isNil(podcastDetail1) &&
      !_.isEqual(podcastDetail1, prevPodcastDetail1)
    ) {
      setPodcastDetailState({
        podcast_id: podcastDetail1.id
          ? podcastDetail1.id.toString()
          : podcastDetail1.preset_id
          ? podcastDetail1.preset_id
          : '',
        title: podcastDetail1.title
          ? podcastDetail1.title //listennote
          : podcastDetail1.text
          ? podcastDetail1.text
          : podcastDetail1.trackName
          ? podcastDetail1.trackName
          : podcastDetail1.name
          ? podcastDetail1.name
          : '',
        country: podcastDetail1.country ? podcastDetail1.country : '',
        author: podcastDetail1.author
          ? podcastDetail1.author
          : podcastDetail1.artistName
          ? podcastDetail1.artistName
          : '', //apple
        genre: podcastDetail1.genres ? podcastDetail1.genres : '',
        language: podcastDetail1.language ? podcastDetail1.language : '', //listennote
        release_date: podcastDetail1.primaryGenreName
          ? podcastDetail1.primaryGenreName //apple
          : podcastDetail1.releaseDate
          ? podcastDetail1.releaseDate
          : '', //apple
        image: podcastDetail1.image
          ? podcastDetail1.image //listennote
          : podcastDetail1.artworkUrl600 ?? podcastDetail1.artworkUrl100,
        description: podcastDetail1.description
          ? podcastDetail1.description //listennote
          : podcastDetail1.subtext
          ? podcastDetail1.subtext
          : podcastDetail1.trackCensoredName
          ? podcastDetail1.trackCensoredName //apple
          : podcastDetail1.copyright
          ? podcastDetail1.copyright
          : '' //apple
      });
    } else if (
      !_.isNil(podcastDetail2) &&
      !_.isEqual(podcastDetail2, prevPodcastDetail2)
    ) {
      setPodcastDetailState({
        podcast_id: podcastDetail2.id ?? podcastDetail2.itunesId,
        title: podcastDetail2.title ?? '',
        country: podcastDetail2.country ?? '',
        author: podcastDetail2.author ?? '', //apple
        genre: podcastDetail2.genres ?? [],
        language: podcastDetail2.language ?? '', //listennote
        release_date: podcastDetail2.releaseDate ?? '', //apple
        image: podcastDetail2.artwork ?? podcastDetail2.artworkUrl100,
        description: podcastDetail2.description ?? '' //apple
      });
    }
  }, [podcastDetail1, prevPodcastDetail1, podcastDetail2, prevPodcastDetail2]);

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  const expandChangeHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const {
    podcast_id,
    title,
    country,
    author,
    genre,
    language,
    release_date,
    image,
    description
  } = podcastDetailState;

  // if (language.toString().includes('en')) {
  //   language = 'English';
  // }

  const podcastLink = `${window.location.origin}/podcast/${podcast_id}`;

  const isHearted = heartedPodcastIds.indexOf(podcast_id) !== -1;

  const getGenres = () => {
    let name = '';
    genre &&
      genre.forEach((genres) => {
        if (typeof genres === 'object') {
          name = genres.name + ', ';
        } else if (typeof genres === 'string') {
          name = genres + ', ';
        }
      });
    name = name.replace(new RegExp(', $'), '');
    return name;
  };

  const onMediaFallback = (event) => {
    if (matchesXS) {
      event.target.src = radioImgXS;
    } else {
      event.target.src = radioImg;
    }
  };

  const handlePlaying = () => {
    console.log('podcast playing...');

    const episodeList = playlists[currentlyViewedPlaylist] ?? [];
    if (episodeList.length) {
      onEpisodePlayerStart(currentlyViewedPlaylist, episodeList[0]);
      onSetCurrentPodcastid(currentlyViewedPlaylist);
      onSetPodcastQueue(currentlyViewedPlaylist, episodeList[0]);
    }
    // onEpisodePlayerStart(episodeid);
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const index = heartedPodcastIds.indexOf(podcast_id);
    if (index === -1) {
      onShowSnackbarNotification(`Podcast Hearted ❤️`);
      onFavouritePodcast(podcast_id);
    } else {
      onShowSnackbarNotification(`Podcast Un-hearted 😢`);
      onRemoveFavoritePodcastStart(podcast_id);
    }
  };

  const onShareClickHandler = (event) => {
    setSocialShareMenuOpen((prevState) => !prevState);
    setShareAnchorEl(event.currentTarget);
    event.preventDefault();
    // props.onShareClickHandler(podcastid);
  };

  const id2 = socialShareMenuOpen ? 'social-share-popover' : undefined;

  let audioStatus;
  if (player.state === -1) {
    audioStatus = 'loading';
  } else if (player.state === 0) {
    audioStatus = 'paused';
  } else if (player.state === 1) {
    audioStatus = 'playing';
  }

  const episodeList = playlists[currentlyViewedPlaylist] ?? [];

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden smUp>
          <div className={classes.container}>
            <Typography className={classes.title}>
              <span
                className="line-clamp"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </Typography>
            <div className={classes.subtitle}>
              <div>
                <span className={clsx('locator', classes.locator)} />
                by {author ? author : <Skeleton variant="text" width={100} />}
              </div>
              {/*<div style={{ marginLeft: 30 }}>
                <span className={clsx('locator', classes.locator)} />
                {language ? language : release_date ? release_date : <Skeleton variant="text" width={100}/>}
              </div>*/}
            </div>
            <div className={classes.detailWrapper} onClick={handlePlaying}>
              <div className={classes.mediaWrapper}>
                {image ? (
                  <CardMedia
                    alt="Image not available"
                    component="img"
                    className={classes.cardImage}
                    src={image}
                    onError={onMediaFallback}
                  />
                ) : (
                  <ImageSkeleton />
                )}
              </div>
              <div className={clsx('outerCircle', classes.outerCircle)} />
              {/*mobile*/}
              <CardContent className={classes.playerIcon}>
                <Grid container justify="center">
                  {episodeid === (episodeList.length ? episodeList[0] : '') ? (
                    <PlayPauseButton
                      main={true}
                      size={35}
                      player={playerRef}
                      status={audioStatus}
                    />
                  ) : (
                    <PlayArrowIcon
                      style={{
                        fontSize: 35,
                        padding: 5,
                        fill: '#fff',
                        background: theme.palette.pink,
                        borderRadius: '50%'
                      }}
                    />
                  )}
                  {/*<PlayArrowIcon className={classes.icon} />*/}
                </Grid>
              </CardContent>
            </div>
            <div className={classes.textWrapper1}>
              {description ? (
                <div
                  className={clsx('description', classes.descriptionMore, {
                    [classes.description]: showMore
                  })}
                >
                  <span
                    className="line-clamp"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>
              ) : (
                <Box pt={0.5}>
                  <Skeleton />
                  <Skeleton width="60%" />
                </Box>
              )}
              {genre && (
                <div className={clsx('genres-div', classes.genresMore)}>
                  {getGenres()}
                </div>
              )}
              {/*{showMore ? (
                <span className={classes.more} onClick={handleShowMore}>
                  Show More
                </span>
              ) : (
                <span className={classes.more} onClick={handleShowMore}>
                  Show Less
                </span>
              )}*/}
            </div>
            <div className={classes.actions}>
              <HeartButton
                style={style}
                name={'Podcast'}
                isHearted={isHearted}
                onFavouriteClickHandler={onFavouriteClickHandler}
              />
              <ShareButton
                style={style}
                onShareClickHandler={onShareClickHandler}
              />
            </div>
          </div>
        </Hidden>
        <Hidden xsDown>
          <div className={classes.container}>
            <div className={classes.cardWrapper} onClick={handlePlaying}>
              {image ? (
                <CardMedia
                  alt="Image not available"
                  component="img"
                  className={classes.cardImage}
                  src={image}
                  onError={onMediaFallback}
                />
              ) : (
                <ImageSkeleton />
              )}
              <div
                className={clsx(
                  'trendingBoxOverlay',
                  classes.trendingBoxOverlay
                )}
              />
            </div>
            <div
              className={clsx('outerCircle', classes.outerCircle)}
              onClick={handlePlaying}
            />
            {/*desktop*/}
            <CardContent className={classes.playerIcon} onClick={handlePlaying}>
              <Grid container justify="center">
                {episodeid === (episodeList.length ? episodeList[0] : '') ? (
                  <PlayPauseButton
                    main={true}
                    size={30}
                    player={playerRef}
                    status={audioStatus}
                  />
                ) : (
                  <PlayArrowIcon
                    style={{
                      fontSize: 30,
                      padding: 10,
                      fill: '#fff',
                      background: theme.palette.pink,
                      borderRadius: '50%'
                    }}
                  />
                )}
                {/*<PlayArrowIcon className={classes.playIcon} />*/}
              </Grid>
            </CardContent>
            <div className={classes.textWrapper}>
              <Typography className={classes.title}>
                <span
                  className="line-clamp"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </Typography>
              <div className={classes.subtitle}>
                <div>
                  <span className={clsx('locator', classes.locator)} />
                  by {author ? author : <Skeleton variant="text" width={100} />}
                </div>
                {/*<div style={{ marginLeft: 30 }}>
                  <span className={clsx('locator', classes.locator)} />
                  {language ? language : release_date ? release_date : <Skeleton variant="text" width={100}/>}
                </div>*/}
              </div>
              {description ? (
                <div
                  className={clsx('description', classes.descriptionMore, {
                    [classes.description]: showMore
                  })}
                >
                  <span
                    className="line-clamp"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>
              ) : (
                <Box pt={0.5}>
                  <Skeleton />
                  <Skeleton width="60%" />
                </Box>
              )}
              {genre && (
                <div className={clsx('genres-div', classes.genresMore)}>
                  {getGenres()}
                </div>
              )}
              {/*{showMore ? (
                <span className={classes.more} onClick={handleShowMore}>
                  Show More
                </span>
              ) : (
                <span className={classes.more} onClick={handleShowMore}>
                  Show Less
                </span>
              )}*/}
              <div className={classes.actions}>
                <HeartButton
                  style={style}
                  name={'Podcast'}
                  isHearted={isHearted}
                  onFavouriteClickHandler={onFavouriteClickHandler}
                />
                <ShareButton
                  style={style}
                  onShareClickHandler={onShareClickHandler}
                />
              </div>
            </div>
          </div>
        </Hidden>
        <Popover
          id={id2}
          open={socialShareMenuOpen}
          anchorEl={shareAnchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          onClose={() => {
            setSocialShareMenuOpen(false);
            setShareAnchorEl(null);
          }}
        >
          <ShareButtons
            className={classes.socialWrapper}
            url={podcastLink}
            title={`Check out ${title}`}
            noPinterest
          />
        </Popover>

        <div className={classes.informationContainer}>
          {expanded ? (
            <Typography className={classes.informationTitle}>
              {'Less Information'}
            </Typography>
          ) : (
            <Typography className={classes.informationTitle}>
              {'More Information'}
            </Typography>
          )}
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded
            })}
            style={{ pointer: 'cursor' }}
            onClick={expandChangeHandler}
          >
            <ExpandMoreIcon className={classes.iconMore} />
          </IconButton>
        </div>
        <div className={classes.informationContainer}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Typography className={classes.detailTitle}>Location: </Typography>
            <Typography className={classes.details}>{country}</Typography>
            <Typography className={classes.detailTitle}>Genres: </Typography>
            <Typography className={classes.details}>
              {/*{genres &&
                genre &&
                genres
                  .filter((e) => genre.includes(e.id))
                  .map((genres) => genres.name + ', ')}*/}
              {getGenres()}
            </Typography>
            <Typography className={classes.detailTitle}>Language: </Typography>
            <Typography className={classes.details}>{language}</Typography>
            <Typography className={classes.detailTitle}>
              Description:{' '}
            </Typography>
            <span
              className={classes.details}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Collapse>
        </div>
      </CardContent>
    </Card>
  );
};

export default container(PodCastDetailCard);
